import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterWrapper = styled.footer`
  background-color: #f8f8f8;
  color: #222;
  padding: 40px 20px;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-family: 'Figtree', 'sans-serif';
`;

export const FooterContainer = styled.div`
  max-width: 1200px;
  margin: auto;
`;

export const FooterLogo = styled.div`
  margin-bottom: 30px;
  img {
    width: 150px;
    height: auto;
  }
`;

export const FooterMenuBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const FooterColumn = styled.div`
  min-width: 150px;
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  font-family: 'FigtreeBold', 'sans-serif';
`;

export const FooterAnchorTag = styled.a`
  color: inherit;
  text-decoration: none;
  margin-bottom: 6px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  margin-bottom: 6px;

  &:hover {
    text-decoration: underline;
  }
`;

export const FooterContent = styled.div`
  p {
    margin: 4px 0;
  }
`;

export const FooterAddress = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const FooterCopyright = styled.div`
  border-top: 1px solid #ddd;
  padding-top: 20px;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const FooterLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const MarketplaceLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const MarketplaceLogo = styled.img`
  width: 30px;
  height: auto;
  cursor: pointer;

  /* @media (max-width: 768px) {
    width: 80px;
    margin-right: 10px;
  } */
`

export const FooterInstagram = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 20px;
    height: 20px;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;